import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';

export const transferApi = {
  getSupportedCurrencies(query) {
    return http.get(API_URLS.CROSS_SITE_TRANSFER_SUPPORTED_CURRENCIES, {
      query,
      formatter(data) {
        const {total} = data;
        const rows = data.rows.map((o) => ({text: o, value: o, currency: o}));
        return {total, rows};
      },
    });
  },
  updateTransferOut(params) {
    return http.post(API_URLS.CROSS_SITE_TRANSFER_OUT, {params});
  },
  getConnectionUser(query) {
    return http.get(API_URLS.CROSS_SITE_CONNECTION_USER, {query});
  },
  quickRegister(query, params) {
    return http.post(API_URLS.CROSS_SITE_QUICK_REGISTER, {query, params});
  },
};
